import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import CategoryComponent from '../components/category.component';
import { categories } from '../../../../../redux/categories/action';
import { selectCategoriesListItems, selectCategoriesQueryItems } from '../../../../../redux/categories/selector';
import PageLoader from '../../../../../components/PageLoader';

const ManagementCategory= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const categoryQuery = useSelector(selectCategoriesQueryItems)
  const categoryListItems = useSelector(selectCategoriesListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const parentCategories = categoryListItems?.result?.items.filter(
  (subCategoryData: any) => subCategoryData.IsSubCategory === false
)
const [
    selectedCategory,
    setSelectedCategory
  ] = useState<any>({})
 

  const fetchCategoryById= ()=>{
    dispatch(categories.query({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/query`,entity:'categories',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
}).then(()=>{
  setIsLoading(false)
})
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedCategory({ ...selectedCategory, [field]: event });
  }
 
  const  handleParentCategorySearch = ({ event }: any) => {
    dispatch(categories.list({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,entity:'categories',jsonData:{
          "Filters": [
            {
              "FieldName": "Name",
              "FilterOperatorId": 6,
              "FieldValue": event,
              "FieldType": "text"
            }
          ], 
        }}))
  }
  useEffect(
    () => {
      
      if (parmas?.id > 0) {
        fetchCategoryById()
        setIsLoading(false)
      }else{
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedCategory(categoryQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
     dispatch(categories.update({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories`,entity:'categories',jsonData:{
          
    Records: [
        selectedCategory
    ]
 
}})).then(() => {
  back()
})

    }else{
      dispatch(categories.create({url:`https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories`,entity:'categories',jsonData:{
          
      Records: [
        selectedCategory
      ]
    
  }}))
  .then(() => {
    back()
})
    }
   
    
  }

const back=()=>{
  navigate('/management/taxonomy/categories')
} 

    return (
    <>
      {isLoading ? <PageLoader /> : 
          <CategoryComponent 
          handleParentCategorySearch={handleParentCategorySearch}
          parentCategories={parentCategories} 
          handleInnerFormChange={handleInnerFormChange}
          selectedCategory={selectedCategory}
          back={back}
          handleFormSubmit={handleFormSubmit}
          />  
        }
          </>
    )
    
    }
   
    export default ManagementCategory;